const stringToColour = (str) => {
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash)
  }
  let colour = '#'
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xff
    colour += value.toString(16).padStart(2, '0')
  }
  return colour
}

export default function createColorClass (name) {
  const color = stringToColour(name)
  const className = `.bg-color-${name.replaceAll(' ', '-').toLowerCase()}`
  const css = `${className} { background-color: ${color} !important; }`

  const styleElement = document.createElement('style')
  styleElement.appendChild(document.createTextNode(css))
  document.head.appendChild(styleElement)

  return className
}



// WEBPACK FOOTER //
// ./src/shared/utils/stringToColor.js